import {
  getDefaultClient,
  getWalletProviderFromWalletAccount,
} from '@dynamic-labs-sdk/client/core';

import { NotStarknetProviderError } from '../errors/NotStarknetProviderError';
import { isStarknetWalletProvider } from '../isStarknetWalletProvider';
import type { StarknetWalletAccount } from '../StarknetWalletAccount.types';

type GetStarknetAccountParams = {
  walletAccount: StarknetWalletAccount;
};

export const getStarknetAccount = async (
  { walletAccount }: GetStarknetAccountParams,
  client = getDefaultClient()
) => {
  const provider = getWalletProviderFromWalletAccount(
    { walletAccount },
    client
  );

  if (!isStarknetWalletProvider(provider)) {
    throw new NotStarknetProviderError({ providerKey: provider.key });
  }

  return provider.getStarknetAccount({ walletAccount });
};
